import { useCallback } from 'react';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { useSelector } from 'src/store/store';
import { useModalTrigger } from 'src/utils/hooks';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import TagNavbar from 'src/modules/tag/tagNavbar';
import NHSContent from 'src/modules/tag/NHSContent';
import { titleSmall, titleLarge } from 'styles-js/mixins/typography';
import { LinkButton } from 'styles-js/buttons';
import { ModalType } from 'src/constants/modalTypes';
import { TagPageProps } from 'src/modules/tag/types';
export default function TagHeader({
  longName,
  tagName,
  type: resultsType
}: TagPageProps) {
  const isLoading = useSelector(state => state.pages.tag.NHS.isLoading);
  const isError = useSelector(state => state.pages.tag.NHS.isError);
  const triggerNHSModal = useModalTrigger(ModalType.NHSTagContent, {
    tagName: longName
  });
  const readMore = useCallback(() => {
    triggerNHSModal();
    trackFootfallEvent(Event.Clicked, {
      clickType: 'nhs-editorial'
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Header data-sentry-element="Header" data-sentry-component="TagHeader" data-sentry-source-file="tagHeader.tsx">
      <HeaderInner data-sentry-element="HeaderInner" data-sentry-source-file="tagHeader.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="tagHeader.tsx"><Text data-sentry-element="Text" data-sentry-source-file="tagHeader.tsx">{i18n.t('Experiences with')}</Text>{longName}</Title>
        {!isLoading && !isError && <>
            <NHSWrapper>
              <NHSContent />
            </NHSWrapper>
            <ReadMoreButton onClick={readMore}>{i18n.t('Read more...')}</ReadMoreButton>
          </>}
      </HeaderInner>
      <TagNavbar resultsType={resultsType} tagName={tagName} data-sentry-element="TagNavbar" data-sentry-source-file="tagHeader.tsx" />
    </Header>;
}
const Header = styled.div`
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 15px;
  background-color: ${({
  theme
}) => theme.colorWhite};

  @media (${({
  theme
}) => theme.underScreenXlarge}) and (${({
  theme
}) => theme.overScreenSmall}) {
    margin-left: 20px;
  }
`;
const HeaderInner = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
`;
const Text = styled.p`
  ${titleSmall};
  color: ${({
  theme
}) => theme.colorTextLight};
`;
const Title = styled.h1`
  ${titleLarge};
  padding-bottom: 15px;
  margin: 0;
`;
const NHSWrapper = styled.div`
  height: calc(${({
  theme
}) => theme.fontLineHeightS} * 3.2);
  overflow: hidden;
  a {
    color: ${({
  theme
}) => theme.colorTextBlack};
  }
  p, h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0;
  }
  ul li {
    padding-left: 0;
    text-indent: 0;
    ::before {
      content: "";
    }
  }
`;
const ReadMoreButton = styled(LinkButton)`
  padding: 20px 0 0;
`;